var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmpt-support"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/logo-gary.png"),"alt":""}}),_c('span',{staticClass:"text"},[_vm._v("好看鸭提供技术支持")])])
}]

export { render, staticRenderFns }